/* __next_internal_client_entry_do_not_use__ TileBadge auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { InsiderBadge } from "@faire/retailer-visitor-shared/components/InsiderBadge/InsiderBadge";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
export var TileBadge = function(param) {
    var className = param.className, hasFreeDuties = param.hasFreeDuties, hasFreeShipping = param.hasFreeShipping, insiderBadgeText = param.insiderBadgeText;
    var showShortenedText = useViewport().isTabletAndBelow;
    return /*#__PURE__*/ _jsx(InsiderBadge, {
        className: className,
        showShortText: showShortenedText,
        showFreeDuties: hasFreeDuties,
        showFreeShipping: hasFreeShipping,
        insiderBadgeText: insiderBadgeText
    });
};
